module.exports = __webpack_public_path__ + "static/chart-1ed34bbbf1f0f25d419e3a2155e14af9.svg";